import type { IconName } from '../../../components/icons/AppIcon';

export type BlockerStatus = 'past_due' | 'canceled' | 'blocked' | 'trial_expired' | 'no_plan';

export interface BlockerConfig {
    title: string;
    description: string;
    icon: IconName | 'none';
    gradient: string;
    iconBg: string;
    iconColor: string;
    buttonText: string;
    showLogout: boolean;
    features?: string[];
}

export const blockerConfig: Record<BlockerStatus, BlockerConfig> = {
    past_due: {
        title: 'Pagamento Pendente',
        description: 'Seu pagamento está atrasado. Regularize para continuar usando o sistema.',
        icon: 'credit-card',
        gradient: 'from-amber-500 to-orange-600',
        iconBg: 'bg-amber-100',
        iconColor: 'text-amber-600',
        buttonText: 'Atualizar Pagamento',
        showLogout: false,
    },
    canceled: {
        title: 'Assinatura Cancelada',
        description: 'Sua assinatura foi cancelada. Renove para continuar aproveitando todos os recursos.',
        icon: 'refresh',
        gradient: 'from-orange-500 to-red-500',
        iconBg: 'bg-orange-100',
        iconColor: 'text-orange-600',
        buttonText: 'Renovar Assinatura',
        showLogout: false,
    },
    blocked: {
        title: 'Acesso Bloqueado',
        description: 'Sua conta foi bloqueada por inadimplência. Regularize seu pagamento para restaurar o acesso.',
        icon: 'shield',
        gradient: 'from-red-500 to-rose-600',
        iconBg: 'bg-red-100',
        iconColor: 'text-red-600',
        buttonText: 'Regularizar Agora',
        showLogout: false,
    },
    trial_expired: {
        title: 'Período de Teste Encerrado',
        description: 'Seu período de teste de 7 dias terminou. Escolha um plano para continuar.',
        icon: 'clock',
        gradient: 'from-blue-500 to-blue-700',
        iconBg: 'bg-blue-100',
        iconColor: 'text-blue-600',
        buttonText: 'Escolher Plano',
        showLogout: true,
        features: [
            'Acesso ilimitado a todas as funcionalidades',
            'Integrações com WhatsApp e Meta Ads',
            'Relatórios avançados em tempo real',
            'Suporte prioritário',
        ],
    },
    no_plan: {
        title: 'Bem-vindo ao Adlitics!',
        description: 'Para começar a usar, escolha um plano e inicie seu teste grátis de 7 dias.',
        icon: 'none',
        gradient: 'from-blue-500 to-blue-700',
        iconBg: 'bg-white',
        iconColor: '',
        buttonText: 'Ver Planos e Começar',
        showLogout: true,
        features: [
            '7 dias grátis para testar',
            'Sem compromisso, cancele quando quiser',
            'Configuração em menos de 5 minutos',
        ],
    },
};
